<template>
  <div id="artscrollhidden">
    <header-top></header-top>
    <div class="contentstart">
      <div class="absolutetopbox" :class="{animateparent:isanimateparent}">
        <div class="banner">
          <div class="bannercenter">
            <div class="artbanner">
              <div @click="navBar" class="detaillist">
                <div></div>
              </div>
            </div>
          </div>
        </div>

        <div class="schoolformlist">
          <swp_school_group @update-item-list="updateItemList" />
        </div>
      </div>

      <div class="artfixed" :class="{fixlayout:isfixlayout}"></div>
      <div class="artschoolmenu" :class="{leftbarstyle:isleftbarstyle}">
        <p>{{$t('global.全部院校')}}</p>
        <ul>
          <li v-for="item in SchoolList" :key="item.id">
            <router-link
              :to="'/subjectdetail/' + item.id"
              class="todatail"
              target="_blank"
            >{{item.title}}</router-link>
          </li>
        </ul>
        <img class="closeMenu" @click="closeMenu" src="/static/closeMenu.png" />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTop from "@/components/v2/Header.vue";
import pages from "../../components/pages.vue";
/*  import ContentEmpty from "../../components/ContentEmpty";*/
import { swiper, swiperSlide } from "vue-awesome-swiper";
/* import SubjectMember1 from "../../pages/subject/SubjectMember1.vue";
  import discussArea from "../../pages/subject/discussArea.vue";*/
import "swiper/dist/css/swiper.css";
/*  import SubjectDetailRight from "./SubjectDetailRight";*/
import swp_school_group from "../../components/list/swp_school_group.vue";

export default {
  name: "SubjectDetail",
  components: {
    HeaderTop,
    pages,
    swiper,
    swiperSlide,
    swp_school_group
  },
  data() {
    return {
      topicId: -1,
      pagerParam: {
        pageSize: 5,
        pageCount: 1,
        currentPage: 1,
        total: 1,
        hasNextPage: false
      },
      bannerSlideList: [],

      SchoolList: [],

      //style
      isanimateparent: false,
      isleftbarstyle: false,
      isfixlayout: true
    };
  },
  created() {
    this.topicId = this.$query.topicId;
  },
  methods: {
    navBar() {
      this.isanimateparent = true;

      this.isfixlayout = false;
      this.isleftbarstyle = true;
    },
    closeMenu() {
      this.isanimateparent = false;

      this.isfixlayout = true;
      this.isleftbarstyle = false;
    },
    updateItemList(data) {
      this.SchoolList = data.list;
    }
  },

  watch: {}
};
</script>

<style scoped>
.contentstart {
  height: calc(100vh - 55px);
}
#artscrollhidden {
  height: 100vh;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}
.absolutetopbox {
  position: relative;
  left: 0;
  transition: all 0.3s ease;
}
.animateparent {
  left: 420px;
  transition: all 0.3s ease;
}
.fixlayout {
  display: none;
}
.artfixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
}
.artschoolmenu {
  position: fixed;
  width: 420px;
  z-index: 10000;
  top: 55px;
  left: -420px;
  opacity: 0;
  height: calc(100% - 55px);
  background-color: #fff;
  transition: all 0.3s ease;
}
.artschoolmenu > p {
  color: #7d7d7d;
  font-size: 16px;
  height: 110px;
  padding-left: 30px;
  line-height: 110px;
  border-bottom: 1px solid #f8f8f8;
  box-sizing: border-box;
}
.artschoolmenu ul {
  padding: 0 30px;
  height: calc(100% - 110px);
  overflow-y: auto;
  overflow-x: hidden;
}
.artschoolmenu li {
  padding: 15px 0;
  border-bottom: 1px solid #f8f8f8;
}
.artschoolmenu li a.todatail {
  display: block;
  font-size: 18px;
  color: #333;
  font-weight: bold;
  cursor: pointer;
}
.artschoolmenu li a {
  color: #7d7d7d;
  font-size: 12px;
}
.closeMenu {
  position: absolute;
  top: 45px;
  right: 30px;
  cursor: pointer;
}

.leftbarstyle {
  opacity: 1;
  left: 0;
  transition: all 0.3s ease;
}

.artbanner {
  position: relative;
  height: 112px;
  background: url("/static/highSchool.png") no-repeat center center;
  background-size: cover;
  object-fit: fill;
}

.schoolformlist {
  height: calc(100vh - 167px);
  background-color: #fff;
  box-sizing: border-box;
}
.schoolformlist .parentswiper {
  width: auto !important;
  margin: 0 auto 0;
}
.detaillist {
  position: absolute;
  width: 25px;
  height: 23px;
  top: 50%;
  left: 50px;
  cursor: pointer;
  transform: translate(0, -50%);
}
.detaillist:before {
  position: absolute;
  display: block;
  content: "";
  width: 25px;
  height: 2px;
  top: 0;
  left: 0;
  background-color: #e2e2e2;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
}
.detaillist:after {
  position: absolute;
  display: block;
  content: "";
  width: 25px;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #e2e2e2;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
}
.detaillist div {
  width: 25px;
  height: 2px;
  margin-top: 10px;
  background-color: #e2e2e2;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
}
</style>





// WEBPACK FOOTER //
// src/pages/subject/artSchoolPage.vue